/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 17.03.14
 *   Time: 12:51
 */

import { BasicEnum } from "../../constants/enums/BasicEnum";

/**
 * Enumeration class handles time
 */
export class TimeType extends BasicEnum {
    private static _values: TimeType[] = [];

    public static MILLISECONDS: TimeType = new TimeType("milliseconds", null, 1, TimeType.instantiationKey);
    public static SECONDS: TimeType = new TimeType("seconds", TimeType.MILLISECONDS, 1000, TimeType.instantiationKey);
    public static MINUTES: TimeType = new TimeType("minutes", TimeType.SECONDS, 60, TimeType.instantiationKey);
    public static HOURS: TimeType = new TimeType("hours", TimeType.MINUTES, 60, TimeType.instantiationKey);
    public static DAYS: TimeType = new TimeType("days", TimeType.HOURS, 24, TimeType.instantiationKey);
    public static WEEKS: TimeType = new TimeType("weeks", TimeType.DAYS, 7, TimeType.instantiationKey);
    public static MONTHS: TimeType = new TimeType("months", TimeType.WEEKS, 4, TimeType.instantiationKey);
    public static YEARS: TimeType = new TimeType("years", TimeType.MONTHS, 12, TimeType.instantiationKey);
    public static MILLENNIUMS: TimeType = new TimeType("millenniums", TimeType.YEARS, 1000, TimeType.instantiationKey);
    public static BIGGEST: TimeType = TimeType.MILLENNIUMS;
    public static SMALLEST: TimeType = TimeType.MILLISECONDS;

    public static get values(): TimeType[] {
        return TimeType._values.concat();
    }

    public static getByName(name: string): TimeType {
        return (<TimeType>BasicEnum.getByProperty(TimeType, 'name', name, null));
    }

    constructor(name: string, previous: TimeType, rate: number, doNotInstantiate: number) {
        super(name, doNotInstantiate);
        this._milliseconds = rate * (previous ? previous.milliseconds : 1);
        this._previous = previous;
        this._rate = rate;
        TimeType._values.push(this);
    }

    private _milliseconds: number;
    private _previous: TimeType;
    private _rate: number;

    public get milliseconds(): number {
        return this._milliseconds;
    }

    public get previous(): TimeType {
        return this._previous;
    }

    public get rate(): number {
        return this._rate;
    }
}
